<template>
  <div>
    <pcHeaders></pcHeaders>

    <div style="position: relative">
      <el-carousel :interval="5000" arrow="always" height="400px">
        <el-carousel-item v-for="item in carouselList" :key="item.id">
          <img :src="item.picUrl" style="position: relative; z-index: 999; width: 100%" @click="toGetPicMessage(item)" alt="" />
        </el-carousel-item>
      </el-carousel>
      <!--      <div class="pos">-->
      <!--        <div class="newsBox">-->
      <!--          <div class="flex"-->
      <!--               style="justify-content: space-between;padding:  0 16px;">-->
      <!--            <div style="font-size: 18px;">通知公告</div>-->
      <!--            <div class="flex"-->
      <!--                 style="cursor: pointer;;color: #999999;font-size: 14px;align-items: center;"-->
      <!--                 @click="more">-->
      <!--              <div style="margin-right: 5px;">更多</div>-->
      <!--              <div><img src="../assets/images/arrow_right.png"-->
      <!--                     alt=""></div>-->
      <!--            </div>-->
      <!--          </div>-->

      <!--          <div class="newList flex"-->
      <!--               style="align-items: center;"-->
      <!--               v-for="item in tzggList"-->
      <!--               :key="item.ID"-->
      <!--               @click="tzgg(item)">-->
      <!--            <div>-->
      <!--              <img style="margin-top: 4px;"-->
      <!--                   src="../assets/indexImg/icon_bell.png"-->
      <!--                   alt="">-->
      <!--            </div>-->
      <!--            <div class="listText">-->
      <!--              {{ item.TITLE }}-->
      <!--            </div>-->
      <!--          </div>-->
      <!--&lt;!&ndash;          <router-link to="/xcx">&ndash;&gt;-->
      <!--&lt;!&ndash;            <div class="botmBtn">&ndash;&gt;-->
      <!--&lt;!&ndash;              查看小程序和移动端&ndash;&gt;-->
      <!--&lt;!&ndash;            </div>&ndash;&gt;-->
      <!--&lt;!&ndash;          </router-link>&ndash;&gt;-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
<div style="background-color: 247, 247, 247;"> <div style="color: #fff;font-size: 20px;background-color: #ed6c45;text-align: center;">温馨告知:本平台暂不提供会计、卫生专业继续教育课程学习服务，有相关学习需求的学员，请自行联系对应行业主管部门，确认正确学习平台。</div></div>
    <div class="main-box">
      <div class="container-box">
        <div class="steps">
          <div class="steps-left">
            <!-- <div class="steps-info">
              <div class="info-top">用户学员</div>
              <div class="info-bottom">报名学习流程</div>
            </div> -->
            <div class="steps-img">
              <img src="@/assets/images/liucheng.png" alt="" />
            </div>
          </div>
          <div class="steps-right">
            <div style="margin-bottom: 10px">客服电话</div>
            <div>400-8816-822</div>
          </div>
        </div>
        <div class="aiBox">
          <div class="aiLeft" @click="goAi">
            <img src="../assets/images/ChatGPT.png" alt="" />
          </div>
          <div class="aiVideo">
            <video
              ref="videoPlayer"
              class="video-js vjs-default-skin vjs-big-play-centered"
              controls
              preload="auto"
              width="100%"
              height="auto"
            ></video>
          </div>
        </div>
        <div class="post-container">
          <div class="title">
            <div class="title-left">通知公告</div>
            <div class="title-right" @click="more">查看更多</div>
          </div>
          <div class="post-list">
            <div class="list-item" v-for="(item, index) in tzggList" :key="index" @click="tzgg(item)">
              <div class="item-left">
                <div class="left-top">{{ item.PUBLISHTIME.slice(5, 10) }}</div>
                <div class="left-bottom">{{ item.PUBLISHTIME.slice(0, 4) }}</div>
              </div>
              <div class="item-right">
                {{ item.TITLE }}
              </div>
            </div>
          </div>
        </div>
        <div class="study-container">
          <div class="title">
            <div class="title-left">推荐课程</div>
            <div class="title-right" @click="handleTolsitFs()">查看更多</div>
          </div>

          <div class="reList">
            <div class="reBox" v-for="item in classList" :key="item.CNo" @click="goShit(item)">
              <div>
                <img
                  v-if="item.classImage && item.classImage !== null && item.classImage !== ''"
                  :src="item.classImage"
                  alt=""
                  @error="handleError"
                />
                <div
                  v-else
                  style="position: relative; display: flex; justify-content: center; align-items: center; width: 100%; height: 170px"
                >
                  <img style="position: absolute; top: 0; left: 0; width: 100%; height: 100%" src="../assets/indexImg/noimg.png" alt="" />
                  <div
                    style="
                      position: relative;
                      z-index: 11;
                      font-size: 15px;
                      font-family: kaiti;
                      text-align: center;
                      padding: 0 10px;
                      font-weight: bold;
                      color: #355fd9;
                    "
                  >
                    {{ item.className }}
                  </div>
                </div>
              </div>

              <div class="reText">
                <div class="text">
                  {{ item.className }}
                </div>

                <div class="botom">
                  <div class="xue">
                    <div>{{ item.orderCount || 0 }}人报名</div>
                  </div>

                  <div class="botmBtn">¥ {{ item.classPrice }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="study-container">
          <div class="title">
            <div class="title-left">{{ publicCourseInfo.CODE_NAME }}</div>
            <div class="title-right" @click="handleTolsitFs(publicCourseInfo.CODE_NO)">查看更多</div>
          </div>

          <div class="reList">
            <div class="reBox" v-for="item in publicCourseInfo.children" :key="item.ID" @click="handleTolsitFs(item.CODE_NO)">
              <div>
                <img :src="item.classImage" alt="" @error="handleError" />
                <!-- <div
                   style="position: relative;display: flex;justify-content: center;align-items: center;width: 100%;height: 170px;">
                <img style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;;"
                     src="../assets/indexImg/noimg.png"
                     alt="">
                <div style="position: relative;z-index: 11;font-size: 15px;font-family: kaiti;text-align: center;padding: 0 10px;font-weight: bold;color: #355FD9;">
                  {{ item.CName }}
                </div>
              </div> -->
              </div>

              <div class="reText">
                <div class="text">
                  {{ item.className }}
                </div>

                <div class="botom">
                  <div class="xue">
                    <div>{{ item.orderCount ? item.orderCount : '0' }}人报名</div>
                  </div>

                  <div class="botmBtn">¥ {{ item.classPrice ? item.classPrice : '0' }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="study-container">
          <div class="title">
            <div class="title-left">继续教育专业课</div>
            <div class="title-right" @click="handleTolsitFs('0702')">查看更多</div>
          </div>

          <div class="reList">
            <div class="reBox" v-for="(item, index) in recommendList1" :key="index" @click="handleTolsitFs(item.CODE_NO)">
              <div>
                <img
                  v-if="item.classImage && item.classImage !== null && item.classImage !== ''"
                  :src="item.classImage"
                  alt=""
                  @error="handleError"
                />
                <div
                  v-else
                  style="position: relative; display: flex; justify-content: center; align-items: center; width: 100%; height: 170px"
                >
                  <img style="position: absolute; top: 0; left: 0; width: 100%; height: 100%" src="../assets/indexImg/noimg.png" alt="" />
                  <div
                    style="
                      position: relative;
                      z-index: 11;
                      font-size: 15px;
                      font-family: kaiti;
                      text-align: center;
                      padding: 0 10px;
                      font-weight: bold;
                      color: #355fd9;
                    "
                  >
                    {{ item.className }}
                  </div>
                </div>
              </div>

              <div class="reText">
                <div class="text">
                  {{ item.className }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="banner">
      <div style="width: 1200px;">
        <div class="fastTrack">
          <div class="text">
            <img src="../assets/indexImg/title_lf.png"
                 alt="">
            <span>快速</span>通道
            <img src="../assets/indexImg/title_rgt.png"
                 alt="">
          </div>
        </div>

        <div class="fastList">

          <div class="box1"
               @click="goList('0702')">
            <img style="width: 100%;height: 100%;position: absolute;top: 0;"
                 src="../assets/indexImg/step2.png"
                 alt="">

            <div class="textBox">
              <div>专业课</div>
              <div class="bc">

              </div>
              <div class="section-content">
                学习新理论、新技术、新方法,提高创新能力和专业技术水平。
              </div>
            </div>

          </div>
          <div class="box1"
               @click="goList('0703')">
            <img style="width: 100%;height: 100%;position: absolute;top: 0;"
                 src="../assets/indexImg/step3.png"
                 alt="">

            <div class="textBox">
              <div>转岗培训</div>
              <div class="bc">

              </div>
              <div class="section-content">
                掌握新岗位技术业务知识和技能，取得新岗位上岗资格所进行的培训。
              </div>
            </div>

          </div>
          <div class="box1"
               @click="goList('0711')">
            <img style="width: 100%;height: 100%;position: absolute;top: 0;"
                 src="../assets/indexImg/step4.png"
                 alt="">

            <div class="textBox">
              <div>党建培训</div>
              <div class="bc">

              </div>
              <div class="section-content">
                提高党建能力、增强党员意识更好的履行党从严治党责任。
              </div>
            </div>

          </div>
          <div class="box1"
               @click="goList('0702','070271')">
            <img style="width: 100%;height: 100%;position: absolute;top: 0;"
                 src="../assets/indexImg/step1.png"
                 alt="">
            <div class="textBox">
              <div>科学传播</div>
              <div class="bc">

              </div>
              <div class="section-content">
                旨在培养既懂科学知识,又善于科学传播的复合型人才,为公众提供准确、生动的科学普及服务。
              </div>
            </div>
          </div>
        </div>

        <div class="fastTrack"
             style="margin-top: 78px;">
          <div class="text">
            <img src="../assets/indexImg/title_lf.png"
                 alt="">
            专业继续教育<span>课程资源库</span>
            <img src="../assets/indexImg/title_rgt.png"
                 alt="">
          </div>
        </div>

        <div class="crl">
          <router-link to="/resourcesList">
            <div>
              <img src="../assets/indexImg/8-1.png"
                   alt="">
            </div>
          </router-link>
          <div class="section-right">
            <div class="slistBox"
                 v-for="item in recommendList"
                 :key="item.id"
                 @click="goresources(item)">
              <div>
                <img v-if="item.CImage && item.CImage !==null && item.CImage !== ''"
                     class="boxImg"
                     :src="item.CImage"
                     alt=""
                     @error="handleError">
                <div class="boxImg"
                     v-else
                     style="position: relative;display: flex;justify-content: center;align-items: center;">
                  <img style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;z-index: -1;"
                       src="../assets/indexImg/noimg.png"
                       alt="">
                  <div style="font-size: 15px;font-family: kaiti;text-align: center;padding: 0 10px;font-weight: bold;color: #355FD9;">
                    {{ item.CName }}
                  </div>
                </div>
              </div>

              <div class="textBox"
                   style=" width: 180px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;padding: 0 10px;">
                {{ item.CName }}
              </div>
            </div>

          </div>
        </div>

      </div>

    </div> -->
    <!-- <div class="skillBox">
      <div style="display: flex;justify-content: center;">
        <div class="fastTrack">
          <div class="text">
            <img src="../assets/indexImg/title_lf.png"
                 alt="">
            <span>技能知识</span>提升继续教育服务
            <img src="../assets/indexImg/title_rgt.png"
                 alt="">
          </div>

        </div>
      </div>

      <div style="text-align: center;font-size: 16px;margin-top: 30px;color: #999;font-family: Regular;">
        提供全方位的网络教育解决方案，专业、周到和贴心的服务。
      </div>
      <div style="text-align: center;font-size: 16px;color: #999;margin-top:5px;font-family: Regular;">
        基于网络教育软件产品的定制开发和平台运营，配套的课件资源定制，多项网络教育软件产品和著作权。
      </div>

      <div class="skBn">
        <div style="width: 1200px;display: flex;">
          <div class="skLeft">
            <img src="../assets/indexImg/bg_skill.png"
                 alt="">
            <div class="leftTitle">
              {{ skill.codeName }}
              技能提升
            </div>

            <div style="display: flex;flex-wrap: wrap;">
              <div @click="oncode(item,index)"
                   :class="activeIndex == index ? 'skList active' : 'skList'"
                   v-for="(item,index) in codeList"
                   :key="item.id">
                {{ item.codeName }}
              </div>

            </div>
          </div>

          <div class="skCenter">
            <div>
              <img src="../assets/indexImg/newEntry.png"
                   alt="">
            </div>

            <div class="centerList">
              <div class="listBox"
                   v-for="(item,index) in skillClassList"
                   :key="index"
                   @click="goPay(item)">

                <div>

                  <img v-if="item.classImage && item.classImage !==null && item.classImage !== ''"
                       class="boxImg"
                       :src="item.classImage"
                       alt=""
                       @error="handleError">
                  <div class="boxImg"
                       v-else
                       style="position: relative;display: flex;justify-content: center;align-items: center;">
                    <img style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;z-index: -1;"
                         src="../assets/indexImg/noimg.png"
                         alt="">
                    <div style="font-size: 15px;font-family: kaiti;text-align: center;padding: 0 10px;font-weight: bold;color: #355FD9;">
                      {{ item.className }}
                    </div>
                  </div>
                </div>
                <div class="textBox">
                  {{ item.className }}
                </div>
              </div>

            </div>
          </div>

          <div class="skRight">
            <div class="fagui">
              <div class="fTitle">
                <div>
                  <img src="../assets/indexImg/icon_news.png"
                       alt="">
                </div>
                <div class="tips">政策法规</div>

                <div class="more"
                     @click="more">
                  MORE
                </div>
              </div>

              <div class="cotent">
                <p v-for="item in zcfgList"
                   :key="item.ID"
                   @click="tzgg(item)">
                  {{ item.TITLE }}
                </p>

              </div>
            </div>

            <div class="fagui"
                 style="margin-top: 40px;">
              <div class="fTitle">
                <div>
                  <img src="../assets/indexImg/icon_news.png"
                       alt="">
                </div>
                <div class="tips">行业资讯</div>

                <div class="more"
                     @click="more">
                  MORE
                </div>
              </div>

              <div class="cotent">
                <p v-for="item in hyzxList"
                   :key="item.ID"
                   @click="tzgg(item)">
                  {{ item.TITLE }}
                </p>

              </div>
            </div>
          </div>
        </div>

      </div>

    </div> -->
    <!-- <div class="banner"
         style="background: #f7f7f7;padding-bottom: 50px;">
      <div style="width: 1200px;background: #ffffff;padding-top: 20px;">
        <div class="fastTrack">
          <div class="text">
            <img src="../assets/indexImg/title_lf.png"
                 alt="">
            <span>热门</span>推荐
            <img src="../assets/indexImg/title_rgt.png"
                 alt="">
          </div>
        </div>
      </div>

    </div> -->

    <pcBottom></pcBottom>
    <Baywindow v-if="adPictureWindow !== ''" :adPictureWindow="adPictureWindow" :adPicture="adPicture" />

    <div
      v-if="adPicture !== '' && !showTK"
      style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0, 0, 0, 0.7); z-index: 10000"
    >
      <div
        v-if="adPicture.jumpway == null"
        style="position: absolute; left: 50%; top: 50%; width: 500px; height: 585px; transform: translate(-50%, -50%)"
      >
        <img style="width: 100%; height: 100%" :src="adPicture.picUrl" alt="" />
        <img
          @click="noShwo"
          style="position: absolute; top: -30px; right: -20px; cursor: pointer; width: 40px; z-index: 10001"
          src="../assets/indexImg/closeIcon.png"
          alt=""
        />
      </div>

      <div
        v-if="adPicture.jumpway !== null && adPicture.jumpway !== '02'"
        style="position: absolute; left: 50%; top: 50%; width: 500px; height: 585px; transform: translate(-50%, -50%)"
      >
        <a @click="goMessage(adPicture)" target="_blank"> <img style="width: 100%; height: 100%" :src="adPicture.picUrl" alt="" /></a>
        <img
          @click="noShwo"
          style="position: absolute; top: -30px; right: -20px; cursor: pointer; width: 40px; z-index: 10001"
          src="../assets/indexImg/closeIcon.png"
          alt=""
        />
      </div>

      <div
        v-if="adPicture.jumpway == '02'"
        style="position: absolute; left: 50%; top: 50%; width: 500px; height: 585px; transform: translate(-50%, -50%)"
      >
        <a :href="adPicture.picDesc" target="_blank"> <img style="width: 100%; height: 100%" :src="adPicture.picUrl" alt="" /></a>
        <img
          @click="noShwo"
          style="position: absolute; top: -30px; right: -20px; cursor: pointer; width: 40px; z-index: 10001"
          src="../assets/indexImg/closeIcon.png"
          alt=""
        />
      </div>
    </div>
    <flotRight />
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import pcHeaders from './component/head.vue';
import pcBottom from './component/bottom.vue';
import { findIndexInfo, toHotClassByCode, exportEnrollData, reqGetPublicCourseInfo } from '../api/index';
import Baywindow from './component/Baywindow.vue';
import flotRight from '@/views/component/flotRight.vue';
import videojs from 'video.js'
import 'video.js/dist/video-js.css'
import '@videojs/http-streaming'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    pcHeaders,
    pcBottom,
    Baywindow,
    flotRight
  },
  data() {
    // 这里存放数据
    return {
       player: null,
      videoSrc: 'https://hwcdn-hls.ahsjxjy.com/2026/KJ2026050600001/index.m3u8',
      carouselList: [], //轮播图数据
      recommendList: [], //资源库课程列表
      skillClassList: {}, //技能提升分类
      recommendList1: [
        { classImage: require('@/assets/images/2025.png'), className: '2025年继续教育专业课', CODE_NO: '070201' },
        { classImage: require('@/assets/images/2024.png'), className: '2024年继续教育专业课', CODE_NO: '070202' },
        { classImage: require('@/assets/images/2023.png'), className: '2023年继续教育专业课', CODE_NO: '070203' }
      ],
      activeIndex: null, //点击的样式
      classList: [], //热门的班级列表
      hyzxList: [], //行业资讯
      zcfgList: [], //政策法规
      tzggList: [], //通知公共
      codeList: [], //分类
      defaultImageUrl: require('../assets/images/noimg.png'),
      queryExl: {},
      adPictureWindow: '',
      adPicture: '',
      showTK: false,
      publicCourseInfo: {}
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},

  // 方法集合
  methods: {
    noShwo() {
      console.log(111);
      this.showTK = true;
    },
    handleError(event) {
      event.target.src = this.defaultImageUrl;
    },
    //浮动广告跳转
    goMessage(item) {
      console.log(item);
      this.$router.replace({
        path: '/message',
        query: {
          data: JSON.stringify(item)
        }
      });
    },
    toGetPicMessage(item) {
      console.log(item);
      if (item.jumpway == '02') {
        window.location.href = item.picDesc;
      } else {
        this.$router.push({
          path: '/zxDetil',
          query: {
            id: item.id
          }
        });
      }
    },
    //更多资讯
    more() {
      this.$router.push({
        path: 'tzgg'
      });
    },
    //通知公告点击
    tzgg(item) {
      console.log(item);
      this.$router.push({
        path: 'tzgg',
        query: {
          id: item.ID
        }
      });
    },
    //公需课
    goG() {
      this.$router.push('/gx');
    },
    goList(id, id2) {
      this.$router.push({
        path: '/lsitFs',
        query: {
          fCodeNo: id, //第一级
          codeNo: id2 //第二级
        }
      });
    },
    //课程资源库点击
    goresources(item) {
      console.log(item);
      // this.$router.push({
      //   path: '/resources',
      //   query: {
      //     courseId: item.id
      //   }
      // });
      this.$router.push({
        path: '/classDetail',
        query: {
          classId: item.id
        }
      });
    },
    //技能提升点击
    oncode(item, index) {
      console.log(item);
      let query = {
        codeId: item.id,
        isSills: true,
        isChSkills: false,
        num: 6
      };
      //热门课程班级
      toHotClassByCode(query).then(res => {
        this.skillClassList = res.data.data.classList;
      });
      this.activeIndex = index;
    },
    getList() {
      // 首页数据
      findIndexInfo().then(res => {
        console.log(res.data.data);
        // if (res.data.data == '01') {
        //   window.location.href = 'https://m.ahsjxjy.com';
        //   return false;
        // }
        this.carouselList = res.data.data.picList;
        this.classList = res.data.data.hotCourseList;
        this.codeList = res.data.data.skillschSysCodeList;
        this.recommendList = res.data.data.recommendCourseList;
        this.hyzxList = res.data.data.hyzxList;
        this.zcfgList = res.data.data.zcfgList;
        this.tzggList = res.data.data.tzggList;
        console.log(res.data.data.tzggList);

        this.skillClassList = res.data.data.skillClassList.classList;
        this.adPictureWindow = res.data.data.adPictureWindow;
        this.adPicture = res.data.data.adPicture;
        const recommendItem = this.recommendList.find(item => item.className.includes('教师'));
        function moveToFront(arr, obj) {
          const index = arr.indexOf(obj);
          if (index > -1) {
            arr.splice(index, 1);
            arr.unshift(obj);
          }
        }
        moveToFront(this.recommendList, recommendItem);
      });
      // this.$store.state.m_user.dispatch('updateValue', 1);
    },
    //试听
    goShit(item) {
      this.$router.push({
        path: '/classDetail',
        query: {
          classId: item.id
        }
      });
    },
    goPay(item) {
      this.$router.push({
        path: '/classDetail',
        query: {
          classId: item.id
        }
      });
    },
    handleToMall() {
      this.$router.push('/resourcesList');
    },
    handleTolsitFs(query) {
      this.$router.push({
        path: '/lsitFs',
        query: {
          codeNo: query ? query : ''
        }
      });
    },
      initPlayer() {
      const videoElement = this.$refs.videoPlayer
      this.player = videojs(videoElement, {
        controls: true,           // 显示控制条
        autoplay: false,          // 不自动播放
        preload: 'auto',          // 预加载
        width:'400',
        height:'200',
        html5: {
          hls: {
            overrideNative: true  // 强制使用插件处理 HLS
          }
        },
        controlBar: {
          volumePanel: {
            inline: false
          },
          // 自定义控制条按钮顺序
          children: [
            'playToggle',
            'volumePanel',
            'currentTimeDisplay',
            'timeDivider',
            'durationDisplay',
            'progressControl',
            'liveDisplay',
            'seekToLive',
            'remainingTimeDisplay',
            'customControlSpacer',
            'playbackRateMenuButton',
            'chaptersButton',
            'descriptionsButton',
            'subsCapsButton',
            'audioTrackButton',
            'fullscreenToggle'
          ]
        }
      }, () => {
        console.log('Video.js 播放器已初始化')
        
        this.player.src({
          src: this.videoSrc,
          type: 'application/x-mpegURL'
        })
        
     
      })
    },
    getPublicCourseInfo() {
      const params = {
        pageNum: 1,
        pageSize: 10,
        className: '',
        codeNo: '0701'
      };
      reqGetPublicCourseInfo(params).then(response => {
        if (response.data.data.length != 0) {
          this.publicCourseInfo = response.data.data[0];
          this.publicCourseInfo.children.reverse();
        }
      });
    },
    //去ai页面
    goAi(){
       this.$router.push({
        path: 'aipage'
      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getList();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.initPlayer()

    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (isMobile) {
      setTimeout(() => {
        window.location.href = this.$store.state.m_user.MOBILE_URL;
      }, 1000);
    }
    this.getPublicCourseInfo();
  },
    beforeDestroy() {
    // 组件销毁时释放播放器资源
    if (this.player) {
      this.player.dispose()
      this.player = null
    }
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.pos {
  height: 400px;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 998;
  font-family: Regular;
  .newsBox {
    position: absolute;
    width: 220px;
    right: -600px;
    top: 50px;
    z-index: 200;
    height: 300px;
    background: #fff;
    padding: 12px 0 0 0;
    z-index: 999;
    .newList {
      margin-top: 16px;
      padding: 0px 10px 0 16px;
      cursor: pointer;
      .listText {
        font-size: 14px;
        font-weight: 400;
        color: #999;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 0;
        margin-left: 5px;
      }
    }
    .botmBtn {
      position: absolute;
      bottom: 0;
      left: 0;
      text-align: center;
      height: 65px;
      line-height: 65px;
      background: #2878ff;
      color: #fff;
      width: 100%;
      font-size: 16px;
      cursor: pointer;
    }
  }
}
.flex {
  display: flex;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.title {
  width: 100%;
  height: 20px;
  padding: 0 10px;
  border-left: 4px solid #4075f6;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .title-left {
    font-weight: bold;
    font-size: 16px;
    color: #333333;
  }
  .title-right {
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    cursor: pointer;
  }
}
.main-box {
  width: 100%;
  background: #f7f7f7;
  .container-box {
    width: 1200px;
    padding-top: 20px;
    padding-bottom: 30px;
    margin: 0 auto;
    .steps {
      width: 100%;
      height: 80px;
      background-color: #ffffff;
      display: flex;
      .steps-left {
        flex: 1;
        display: flex;
        .steps-info {
          width: 145px;
          height: 100%;
          font-weight: bold;
          font-size: 16px;
          color: #333333;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }
        .steps-img {
          flex: 1;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .steps-right {
        width: 248px;
        height: 100%;
        font-size: 16px;
        color: #ffffff;
        background: #4075f6;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
    }
    .post-container {
      width: 100%;
      padding: 20px 0px;
      margin-top: 20px;
      background-color: #ffffff;
      .post-list {
        width: 100%;
        height: 100%;
        padding: 0 20px 20px 20px;
        display: flex;
        flex-wrap: wrap;
        .list-item {
          width: 50%;
          height: 72px;
          margin-top: 20px;
          display: flex;
          .item-left {
            width: 100px;
            height: 100%;
            background-color: #e8e8e8;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .left-top {
              font-weight: bold;
              font-size: 18px;
              color: #a5a5a5;
            }
            .left-bottom {
              font-weight: bold;
              font-size: 12px;
              color: #a5a5a5;
            }
          }
          .item-right {
            flex: 1;
            font-weight: bold;
            font-size: 14px;
            color: #333333;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            padding: 0 20px;
            cursor: pointer;
          }
        }
      }
    }
    .study-container {
      width: 100%;
      padding-top: 20px;
      margin-top: 20px;
      background-color: #ffffff;
      .reList {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 20px;
        .reBox {
          width: 32%;
          height: 240px;
          box-shadow: 0px 2px 10px #dddddd;
          border-radius: 6px;
          margin-bottom: 20px;
          cursor: pointer;
          img {
            width: 100%;
            height: 170px;
          }
          .reText {
            padding: 9px 10px 0;
            .text {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              font-size: 16px;
              color: rgba(51, 51, 51, 1);
            }
            .botom {
              margin-top: 8px;
              display: flex;
              justify-content: space-between;
              .xue {
                font-size: 12px;
                color: #bbbbbb;
                font-family: Regular;
              }
              .botmBtn {
                padding: 0 14px;
                height: 25px;
                line-height: 25px;
                border-radius: 17px;
                font-size: 18px;
                font-weight: bold;
                color: #4075f6;
                // background: #ff5c10;
                margin-top: -6px;
                font-family: Regular;
              }
            }
          }
        }
        .reBox:nth-child(5n) {
          margin-right: 0 !important;
        }
        .reBox:hover {
          opacity: 0.7;
        }
      }
      .reList::after {
        content: '';
        width: 32%;
      }
    }
  }
}
.banner {
  font-family: Regular;
  display: flex;
  justify-content: center;
  .fastTrack {
    width: 1200px;
    display: flex;
    justify-content: center;
    margin-top: 43px;
    font-family: bold;
    .text {
      font-size: 32px;
      display: flex;
      align-items: center;
      img {
        width: 30px;
        height: 16px;
        margin: 0 15px;
      }
      span {
        color: #2878ff;
      }
    }
  }
  .fastList {
    display: flex;
    margin-top: 37px;

    .box1 {
      width: 285px;
      height: 160px;
      position: relative;
      margin-right: 20px;
      color: #fff;
      cursor: pointer;
      .textBox {
        padding: 33px 0 0 20px;
        font-size: 24px;
        font-family: bold;
        .bc {
          width: 50px;
          height: 4px;
          margin-top: 10px;
          background: #fff;
        }
        .section-content {
          margin-top: 10px;
          width: 170px;
          font-size: 12px;
          font-family: Regular;
          font-weight: 500;
          line-height: 20px;
          color: #ffffff;
          opacity: 0.8;
        }
      }
      img {
        z-index: -1;
      }
    }
  }
  .crl {
    display: flex;
    margin-top: 50px;
    padding-bottom: 70px;
    .section-right {
      display: flex;
      width: 770px;
      height: 400px;
      flex-wrap: wrap;
      margin-left: 10px;
      .slistBox {
        width: 180px;
        height: 190px;
        box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.09);
        margin-right: 15px;
        cursor: pointer;
        .boxImg {
          width: 100%;
          height: 149px;
        }
        .textBox {
          height: 40px;
          line-height: 40px;
          text-align: center;
        }
      }
      .slistBox:nth-child(4n) {
        margin-right: 0 !important;
      }
      .slistBox:nth-child(n + 5):nth-child(-n + 8) {
        margin-top: 12px;
      }
    }
  }
}
.skillBox {
  width: 100%;
  background: #f7f7f7;
  padding: 60px 0 72px 0;

  .fastTrack {
    width: 1200px;
    display: flex;
    justify-content: center;
    font-family: bold;
    .text {
      font-size: 32px;
      display: flex;
      align-items: center;
      img {
        width: 30px;
        height: 16px;
        margin: 0 15px;
      }
      span {
        color: #2878ff;
      }
    }
  }
  .skBn {
    display: flex;
    margin-top: 30px;
    justify-content: center;
    padding-bottom: 20px;
    .skLeft {
      width: 245px;
      height: 618px;
      position: relative;
      padding: 32px 10px 0 20px;
      img {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
      }
      .leftTitle {
        font-family: Medium;
        position: relative;
        font-size: 28px;
        color: #2878ff;
        margin-bottom: 32px;
        font-family: bold;
        z-index: 2;
      }
      .skList {
        font-family: Medium;
        position: relative;
        z-index: 2;
        height: 30px;
        line-height: 30px;
        padding: 0 17px;
        border: 1px solid #2878ff;
        border-radius: 15px;
        color: #2878ff;
        font-size: 14px;
        cursor: pointer;
        margin: 0 10px 15px 0;
        max-width: 220px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .active {
        font-family: Medium;
        position: relative;
        z-index: 2;
        background: #2878ff !important;
        color: #fff !important;
      }
      .skList:hover {
        font-family: Medium;
        position: relative;
        z-index: 2;
        background: #2878ff !important;
        color: #fff !important;
      }
    }
    .skCenter {
      padding-left: 20px;
      font-family: Regular;
      background: #fff;
      .centerList {
        margin-top: 17px;
        width: 670px;
        display: flex;
        flex-wrap: wrap;
        .listBox {
          width: 210px;
          height: 224px;
          margin-right: 20px;
          cursor: pointer;
          img {
            width: 100%;
            height: 174px;
          }
          .textBox {
            font-size: 16px;
            color: #333;
            margin: 13px 0;
          }
        }
        .listBox:nth-child(3n) {
          margin-right: 0 !important;
        }
        .listBox:hover {
          opacity: 0.7;
        }
      }
    }
    .skRight {
      background: #fff;
      width: 245px;
      padding: 20px 20px 0 20px;
      .fagui {
        .fTitle {
          display: flex;
          img {
            width: 15px;
            height: 24px;
          }
          .tips {
            font-family: Regular;
            font-size: 22px;
            margin-left: 10px;
          }
          .more {
            margin-left: 50px;
            color: #ccc;
            padding-top: 7px;
            cursor: pointer;
          }
        }
        .cotent {
          p {
            font-size: 14px;
            color: #999;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            cursor: pointer;
          }
          p:hover {
            opacity: 0.7 !important;
          }
        }
      }
    }
  }
}
.aiBox {
  margin-top: 16px;
  display: flex;
  .aiLeft {
    img {
      width: 780px;
      height: 200px;
      cursor: pointer;
    }
  }
  .aiVideo {
    width: 408px;
    height: 200px;
    margin-left: 12px;
  }
}

</style>
